// Legacy organization IDs used before migrating to Medplum
export enum OrganizationId {
  healix = 'healix', // Healix referrals (child of Healix org)
  healixSso = 'healix-sso',
  landg = 'landg', // L&G referrals (child of L&G org)
  landgci = 'landgci', // L&G CI (child of L&G org)
  aviva = 'aviva', // Aviva referrals
  paycare = 'paycare',
  perci = 'perci',
  bell = 'bell',
  sw2023 = 'sw2023',
  pwc = 'pwc',
  bh2023 = 'bh2023',
  pco = 'pco',
  myhxtras = 'myhxtras',
  mhx23 = 'mhx23',
  internationalpmi = 'internationalpmi',
  occhealthnow = 'occhealthnow',
  macmillan = 'macmillan',
  ff = 'ff',
  d2c = 'd2c',
  cluk = 'cluk',
  vitality = 'vitality',
}
